import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const carouselStyles = tv({
    slots: {
        root: `
      iris:relative 
      iris:h-full 
      iris:w-full`,
        viewport: `
      iris:relative 
      iris:h-full 
      iris:w-full 
      iris:overflow-hidden`,
        fadeOutGradientLeft: `
      iris:pointer-events-none 
      iris:absolute 
      iris:top-0 
      iris:left-0 
      iris:z-10 
      iris:h-full 
      iris:w-(--base-space-px-48) 
      iris:bg-gradient-to-r  
      iris:to-transparent`,
        fadeOutGradientRight: `
      iris:pointer-events-none 
      iris:absolute 
      iris:top-0 
      iris:right-0 
      iris:z-10 
      iris:h-full 
      iris:w-(--base-space-px-48) 
      iris:bg-gradient-to-l 
      iris:to-transparent`,
        container: `
      iris:flex 
      iris:h-full 
      iris:w-full`,
        singleItemPadding: "",
        controls: `
      iris:mt-(--base-space-px-8) 
      iris:grid 
      iris:w-full 
      iris:grid-cols-[auto_1fr] 
      iris:justify-between 
      iris:gap-(--base-space-px-12)
    `,
        buttons: `
      iris:grid 
      iris:grid-cols-2 
      iris:items-center 
      iris:gap-(--base-space-px-8)
    `,
    },
    variants: {
        inverse: {
            true: {
                root: focusStyles.inverse,
                fadeOutGradientLeft: `
        iris:from-(--sem-color-background-neutral-inverse-primary)
        `,
                fadeOutGradientRight: `
        iris:from-(--sem-color-background-neutral-inverse-primary)
        `,
            },
            false: {
                root: focusStyles.default,
                fadeOutGradientLeft: `
        iris:from-(--sem-color-background-neutral-primary)
        `,
                fadeOutGradientRight: `
        iris:from-(--sem-color-background-neutral-primary)
        `,
            },
        },
        animation: {
            fade: {},
            scroll: {},
        },
        showFadeEdge: {
            true: {},
            false: {},
        },
        deviceType: {
            mobile: {},
            desktop: {},
        },
    },
    compoundVariants: [],
    defaultVariants: {
        showFadeEdge: false,
        dimensions: "desktop",
    },
});

export { carouselStyles, carouselStyles as default };
